import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PoiListComponent } from './poi/poi-list/poi-list.component';
import { CategoryComponent } from './category/category.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { PoiDetailComponent } from './poi/poi-detail/poi-detail.component';
import { MapComponent } from './map/map.component';
import { MunicipalityComponent } from './municipality/municipality.component';
import { TitleCasePipe } from '@angular/common';
import { PoiRatingComponent } from './poi/poi-rating/poi-rating.component';
import { AppdownloadComponent } from './appdownload/appdownload.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ImpressumComponent } from './impressum/impressum.component';
import { DatenschutzComponent } from './datenschutz/datenschutz.component';
import { ThumbnailPipe } from './thumbnail.pipe';
import { AccommodationsComponent } from './accommodations/accommodations.component';

@NgModule({
  declarations: [
    AppComponent,
    PoiListComponent,
    CategoryComponent,
    HomeComponent,
    PoiDetailComponent,
    MapComponent,
    MunicipalityComponent,
    PoiRatingComponent,
    AppdownloadComponent,
    ImpressumComponent,
    DatenschutzComponent,
    ThumbnailPipe,
    AccommodationsComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    HttpClientModule,
    NgImageSliderModule
  ],
  providers: [TitleCasePipe, DeviceDetectorService],
  bootstrap: [AppComponent]
})
export class AppModule { }
